import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SnackbarService } from '@app/core/services/snackbar.service';
import { TimezoneService } from '@app/core/services/timezone/timezone.service';
import { Timezone } from '@app/modules/lookup/models/timezone.model';
import { AdpSchedule } from '@app/modules/site-settings-integrations/models/integrations.model';
import { IntegrationsService } from '@app/modules/site-settings-integrations/services/integrations.service';
import { OverlayService } from '@app/shared/components/overlay/overlay.service';
import { TranslateService } from '@ngx-translate/core';
import { finalize } from 'rxjs';

@Component({
  selector: 'app-adp-schedule-dialog',
  templateUrl: './adp-schedule-dialog.component.html',
  styleUrls: ['./adp-schedule-dialog.component.scss']
})
export class AdpScheduleDialogComponent implements OnInit {
  public integrationId: string;
  public schedule?: AdpSchedule;
  public form: any;
  public timezones: Timezone[] = [];
  public loadingTimezones: boolean = false;
  public hours: number[] = Array.from({ length: 24 }, (_, i) => i);
  public minutes: number[] = Array.from({ length: 60 }, (_, i) => i);

  constructor(
    private fb: UntypedFormBuilder,
    private translate: TranslateService,
    private overlayService: OverlayService,
    private snackbarService: SnackbarService,
    private timezoneService: TimezoneService,
    private integrationService: IntegrationsService,
    private dialogRef: MatDialogRef<AdpScheduleDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data
  ) {
    this.integrationId = data.integrationId;
    this.schedule = data.schedule;
    this.createForm();
  }

  ngOnInit(): void {
    this.loadingTimezones = true;

    this.timezoneService.getTimezones()
      .pipe(finalize(() => this.loadingTimezones = false))
      .subscribe(res => {
        this.timezones = res.data;
      });
  }

  createForm() {
    this.form = this.fb.group({
      hour: [this.schedule ? this.schedule.hour : null, Validators.required],
      minute: [this.schedule ? this.schedule.minute : null, Validators.required],
      timezoneId: [this.schedule ? this.schedule.timezoneId : null, Validators.required],
    });
  }

  save() {
    this.overlayService.show();

    const value = this.form.value;

    const request = this.schedule
      ? this.integrationService.updateAdpSchedule(this.integrationId, this.schedule.id, value)
      : this.integrationService.createAdpSchedule(this.integrationId, value);

    request
      .pipe(finalize(() => this.overlayService.hide()))
      .subscribe({
        next: () => {
          this.snackbarService.openSnackBar(this.translate.instant('IntegrationConfigUpdated'), 'clear', 'success');
          this.dialogRef.close(true);
        },
        error: () => { }
      });
  }

  close() {
    this.dialogRef.close();
  }
}
